var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8875 10.282L9.27754 8.97703V4.91203L9.27004 4.82953C9.22504 4.47703 8.92504 4.20703 8.56504 4.20703C8.17504 4.20703 7.85254 4.52953 7.85254 4.91953V9.42703L7.86004 9.52453C7.89754 9.74953 8.04004 9.95203 8.25004 10.057L11.2575 11.557L11.3325 11.587C11.4075 11.617 11.49 11.6245 11.565 11.6245C11.8275 11.6245 12.0825 11.4745 12.2025 11.227L12.2325 11.152C12.36 10.8145 12.21 10.4395 11.8875 10.282Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9625 0.75C4.4325 0.75 0.75 4.4325 0.75 8.9625C0.75 13.4925 4.4325 17.175 8.9625 17.175C13.4925 17.175 17.175 13.4925 17.175 8.9625C17.175 4.4325 13.4925 0.75 8.9625 0.75ZM15.75 8.9625C15.75 12.705 12.705 15.75 8.9625 15.75C5.22 15.75 2.175 12.705 2.175 8.9625C2.175 5.22 5.22 2.175 8.9625 2.175C12.705 2.175 15.75 5.22 15.75 8.9625Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b88b6131af30ef24f0b07afc1bb30405.svg";
export { ForwardRef as ReactComponent };